import type { PropsWithChildren } from 'react'
import { match } from 'ts-pattern'
import IcRoundWarning from '~icons/ic/round-warning'
import { cx } from 'src/utils/cx'

export enum ControlSectionMessageType {
  Message = 0,
  Warning = 1,
}

export function ControlSectionMessage(
  props: StyleProps & PropsWithChildren & { type?: ControlSectionMessageType },
) {
  const type = props.type || ControlSectionMessageType.Message

  return (
    <p
      className={cx(
        'p-2 leading-5 flex rounded-md select-none',
        match(type)
          .with(
            ControlSectionMessageType.Warning,
            () =>
              'bg-amber-100 dark:bg-amber-500/10 text-amber-600 dark:text-amber-500',
          )
          .otherwise(() => null),
        props.className,
      )}
      style={props.style}
    >
      {match(type)
        .with(ControlSectionMessageType.Warning, () => (
          <IcRoundWarning className="flex-none w-5 h-5 inline-block mr-1" />
        ))
        .otherwise(() => null)}
      {props.children}
    </p>
  )
}
